import { render, staticRenderFns } from "./RtlChevronIcon.vue?vue&type=template&id=b1811c54&"
import script from "./RtlChevronIcon.vue?vue&type=script&lang=ts&"
export * from "./RtlChevronIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports